import { RouteProps } from 'react-router-dom';
import { Role } from '../contexts/Authentication';
import Home from './Home';
import Login from './Login';
import Logout from './Logout';
import Users from './Users';
import BestOf from './BestOf/index';
import Subscriptions from './Subscriptions';
import Articles from './Articles';
import Cover from './Cover';
import System from './System';
import Payments from './Payments';
import Category from './Category';
import Check from './Check';
import Authors from './Authors';
import AllSubscriptions from './AllSubscriptions';
import SubStat from './SubStat';
import GlobalStat from './GlobalStat';
// import Unsubscribe from './Unsubscribe';
import Newsletter from './Newsletter';

export interface RouteInterface extends RouteProps {
  name: string
  position: number
  protected?: boolean
  invisible?: boolean
  roles?: Role[]
  nested?: RouteInterface[]
}

const Routes: RouteInterface[] = [
  {
    name: 'Login',
    position: 1,
    path: '/login',
    component: Login,
    protected: false,
    invisible: true
  },
  {
    name: 'Accueil',
    position: 1,
    path: '/',
    component: Home,
    protected: true
  },
  {
    roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Contributeur, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
    name: 'Articles',
    position: 2,
    path: '/articles',
    component: Articles,
    protected: true
  },
  {
    roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
    name: "Catégories",
    position: 3,
    path: '/category',
    component: Category,
    protected: true
  },
  {
    roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
    name: 'Couverture',
    position: 4,
    path: '/cover',
    component: Cover,
    protected: true
  },
  {
    roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
    name: 'Newsletter',
    position: 5,
    path: '/newsletter',
    component: Newsletter,
    protected: true
  },
  {
    roles: [Role.Administrateur],
    name: 'Utilisateurs',
    position: 6,
    path: '/users',
    component: Users,
    protected: true
  },
  {
    roles: [Role.Administrateur],
    name: 'Best Of',
    position: 7,
    path: '/bestof',
    component: BestOf,
    protected: true
  },
  {
    roles: [Role.Administrateur],
    name: 'Mentions',
    position: 8,
    path: '/system',
    component: System,
    protected: true
  },
  {
    roles: [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior],
    name: 'Auteurs',
    position: 9,
    path: '/authors',
    component: Authors,
    protected: true
  },
  {
    roles: [Role.Administrateur],
    name: 'Abonnements',
    position: 10,
    protected: true,
    nested: [
      {
        roles: [Role.Administrateur],
        name: 'Tous les abonnements',
        position: 1,
        path: '/all-subscriptions',
        component: AllSubscriptions,
        protected: true
      },
      {
        roles: [Role.Administrateur],
        name: 'Abonnements Stripe',
        position: 2,
        path: '/subscription',
        component: Subscriptions,
        protected: true
      },
      {
        roles: [Role.Administrateur],
        name: 'Statistiques',
        position: 3,
        path: '/statistics',
        component: SubStat,
        protected: true
      },
      // {
      //   roles: [Role.Administrateur],
      //   name: 'Désabonnements',
      //   position: 3,
      //   path: '/unsubscribe',
      //   component: Unsubscribe,
      //   protected: true
      // }
    ]
  },
  {
    roles: [Role.Administrateur],
    name: 'Statistiques responsive',
    position: 11,
    path: '/statistics-responsive',
    component: GlobalStat,
    protected: true,
    invisible: true,
  },
  {
    roles: [Role.Administrateur],
    name: 'Paiements',
    position: 12,
    protected: true,
    nested: [
      {
        roles: [Role.Administrateur],
        name: 'Paiements Stripe',
        position: 1,
        path: '/payments',
        component: Payments,
        protected: true
      },
      {
        roles: [Role.Administrateur],
        name: 'Paiements Chèques',
        position: 2,
        path: '/check',
        component: Check,
        protected: true
      }
    ]
  },
  {
    name: 'Déconnexion',
    position: 99,
    path: '/logout',
    component: Logout,
    protected: true
  }
].reverse();

export default Routes;